import { BBABalance, BlockNumber } from "components/blockchain";
import { TxHash } from "components/common/TxHash";
import Table from "components/datatable/table";
import { TxInterface } from "interfaces/tx.interface";

type Props = {
  transactions: TxInterface[];
};

const Transactions = ({ transactions }: Props) => {
  const columns = [
    {
      title: "Signature",
      render: (_value: any, tx: TxInterface) => (
        <TxHash hash={tx.signatures[0]} truncate={16} link />
      ),
    },
    {
      title: "Block",
      render: (_value: any, tx: TxInterface) => (
        <BlockNumber height={tx.block_number} link />
      ),
    },
    {
      title: "Fee",
      render: (_value: any, tx: TxInterface) => <BBABalance daltons={tx.fee} />,
    },
  ];

  return (
    <div className="mb-12 mt-6 px-2.5 md:px-3 lg:px-5">
      {/* TXS List */}
      <Table columns={columns} data={transactions} tableClassName="table" />
    </div>
  );
};

export default Transactions;
